import { createEvent, sample } from 'effector';
import arrayMove from '@utils/arrayMove';
import {
  $categoryListApi,
  $categoryMapApi,
  $selectedPath,
} from '@stores/dataStores';

interface Params {
  fromIndex: number;
  toIndex: number;
}

export const sortCategory = createEvent<Params>();
sortCategory.watch((payload) => {
  $categoryListApi.update((draft) => {
    return arrayMove({
      array: draft,
      fromIndex: payload.fromIndex,
      toIndex: payload.toIndex,
    });
  });
});

export const sortSubCategory = createEvent<Params>();
sample({
  source: $selectedPath,
  clock: sortSubCategory,
  fn: (source, clock) => ({ path: source.categoryPath, ...clock }),
}).watch(({ path, fromIndex, toIndex }) => {
  const id = path[0];
  $categoryMapApi.update((draft) => {
    const category = draft.get(id)!;
    category.categoryIds = arrayMove({
      array: category.categoryIds,
      fromIndex,
      toIndex,
    });
  });
});

export const sortScene = createEvent<Params>();
sample({
  source: $selectedPath,
  clock: sortScene,
  fn: (source, clock) => ({ path: source.categoryPath, ...clock }),
}).watch(({ path, fromIndex, toIndex }) => {
  const id = path[path.length - 1];
  $categoryMapApi.update((draft) => {
    const category = draft.get(id)!;
    category.sceneIds = arrayMove({
      array: category.sceneIds,
      fromIndex,
      toIndex,
    });
  });
});
